module.exports = __webpack_public_path__ + "img/30_59.2f960d4a.png";